import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, ErrorLogModel, GithubIssueViewModel, SupportTicketViewModel } from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { ErrorLogApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate } from "@angular/common";
import * as UAParser from 'ua-parser-js';




@Component({
  selector: 'app-exception-log-view-component',
  templateUrl: './exception-log-view.component.html',
  standalone: false
})
export class ExceptionLogViewComponent implements OnInit, AfterViewInit {



  public pageTitle: string = 'Exception Log';


  currentItem?: ErrorLogModel;
  loading: boolean = false;

  gitHubIssueVisible: boolean = false;
  loadingGitHubIssue: boolean = false;
  gitHubIssues: GithubIssueViewModel[] | null = null;
  gitHubIssue: GithubIssueViewModel | null = null;
  gitHubComment?: string;



  ticketVisible: boolean = false;
  loadingTicket: boolean = false;
  tickets: SupportTicketViewModel[] | null = null;
  ticket: SupportTicketViewModel | null = null;

  FullJson?: any;

  ClientSite?: string;
  FullUrl?: any;
  SourceFile?: string;
  SourceFileLine?: number;
  Device?: string;

  CustomData?: any;
  ServerVariables?: any;
  QueryString?: any;
  Form?: any;
  Cookies?: any;
  RequestHeaders?: any;

  User?: any;
  Session?: any;

  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ErrorLogApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = +(params.get('ID') || '0');
      if (ID > 0) {
        console.info('Loading ' + ID);

        this.apiService.Get({ body: { id: ID } })
          .forEach(data => {
            this.loading = false;
            this.load(data);
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

      } else {
        this.router.navigate(['/exceptionlog']);
      }
    });

    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);

  }

  ngAfterViewInit(): void {
    
  }


  async load(data: ErrorLogModel) {

    this.currentItem = data;

    if (data.FullJson) {

      try {
        this.FullJson = JSON.parse(data.FullJson);
        
        delete this.FullJson['ApplicationName'];
        delete this.FullJson['CreationDate'];
        delete this.FullJson['DeletionDate'];
        delete this.FullJson['Detail'];
        delete this.FullJson['DuplicateCount'];
        delete this.FullJson['ErrorHash'];
        //delete this.currentJson['FullJson'];
        delete this.FullJson['GUID'];
        delete this.FullJson['HTTPMethod'];
        delete this.FullJson['Host'];
        delete this.FullJson['IPAddress'];
        delete this.FullJson['IsProtected'];
        delete this.FullJson['LastLogDate'];
        delete this.FullJson['MachineName'];
        delete this.FullJson['Message'];
        delete this.FullJson['Source'];
        delete this.FullJson['StatusCode'];
        delete this.FullJson['Url'];
        delete this.FullJson['Type'];


        if (this.FullJson?.CustomData) {
          this.CustomData = this.FullJson.CustomData;
          delete this.FullJson['CustomData'];
          console.debug('CustomData', this.CustomData);
        }
        if (this.FullJson?.ServerVariablesSerializable) {
          this.ServerVariables = this.serializableToObj(this.FullJson.ServerVariablesSerializable);
          delete this.FullJson['ServerVariablesSerializable'];
          console.debug('ServerVariables', this.ServerVariables);
        }
        if (this.FullJson?.QueryStringSerializable) {
          this.QueryString = this.serializableToObj(this.FullJson.QueryStringSerializable);
          delete this.FullJson['QueryStringSerializable'];
          console.debug('QueryString', this.QueryString);
        }
        if (this.FullJson?.FormSerializable) {
          this.Form = this.serializableToObj(this.FullJson.FormSerializable);
          delete this.FullJson['FormSerializable'];
          console.debug('Form', this.Form);
        } else if (this.CustomData && this.CustomData.JSON) {
          this.Form = this.CustomData.JSON;
          console.debug('Form', this.Form);
          delete this.CustomData['JSON'];
        } else if (this.CustomData && this.CustomData.Body) {
          this.Form = this.CustomData.Body;
          console.debug('Form', this.Form);
          delete this.CustomData['Body'];
        }
        if (this.FullJson?.CookiesSerializable) {
          this.Cookies = this.serializableToObj(this.FullJson.CookiesSerializable);
          delete this.FullJson['CookiesSerializable'];
          console.debug('Cookies', this.Cookies);
        }
        if (this.FullJson?.RequestHeadersSerializable) {
          this.RequestHeaders = this.serializableToObj(this.FullJson.RequestHeadersSerializable);
          delete this.FullJson['RequestHeadersSerializable'];
          console.debug('RequestHeaders', this.RequestHeaders);
        }
        if (this.FullJson?.FullUrl) {
          this.FullUrl = this.FullJson.FullUrl;
          delete this.FullJson['FullUrl'];
          console.debug('FullUrl', this.FullUrl);
        }

        
        if (this.CustomData && this.CustomData.ClientSite) {
          this.ClientSite = this.CustomData.ClientSite;
          delete this.CustomData['ClientSite'];
        } else if (this.CustomData && this.CustomData.ClientDatabase) {
          this.ClientSite = this.CustomData.ClientDatabase;
          delete this.CustomData['ClientDatabase'];
        } else if (this.RequestHeaders && this.RequestHeaders.clientname) {
          this.ClientSite = this.RequestHeaders.clientname;
          //delete this.RequestHeaders['clientname'];
        }


        if (this.Cookies && this.Cookies['DeviceName'] )
        {
          this.Device = this.Cookies['DeviceName'];
        }
        else if (this.RequestHeaders && this.RequestHeaders['User-Agent'])
        {
          this.Device = this.RequestHeaders['User-Agent'];
          if (this.Device) {
            if (/chrome|crios|crmo/i.test(this.Device)) {
              this.Device = 'Chrome';
            } else if (/firefox|fxios/i.test(this.Device)) {
              this.Device = 'Firefox';
            } else if (/safari/i.test(this.Device) && !/chrome|crios|crmo/i.test(this.Device)) {
              this.Device = 'Safari';
            } else if (/msie|trident/i.test(this.Device)) {
              this.Device = 'Internet Explorer';
            } else if (/edg/i.test(this.Device)) {
              this.Device = 'Edge';
            }
          }
          
          let plaform = this.RequestHeaders['sec-ch-ua-platform'];
          if (plaform) {
            plaform = plaform.substring(1, plaform.length - 1);
            this.Device = plaform;
          }
          if (this.RequestHeaders['sec-ch-ua']) {
            let secChUa = this.RequestHeaders['sec-ch-ua'];

            const regex = /"([^"]+)"\s*;\s*v="([^"]+)"/g;
            let match;
            while ((match = regex.exec(secChUa)) !== null) {
              this.Device = `${plaform} ${match[1]} ${match[2]}`.trim();
            }
          }
          {
            var r: Record<string, string> = {};
            for (var k in this.RequestHeaders)
              r[k.toLowerCase()] = this.RequestHeaders[k];
            let parser = new UAParser.UAParser(r);
            
            let result = parser.getResult();
            
            if (result.device.model || result.device.vendor)
              this.Device = `${result.device.vendor} ${result.device.model} ${result.os.name} ${result.os.version} ${result.browser.name} ${result.browser.version}`;
            else if (result.os.name || result.os.version || result.browser.name || result.browser.version)
              this.Device = `${result.os.name} ${result.os.version} ${result.browser.name} ${result.browser.version}`;
          
          }
         
        }

        

        this.User = {};
        this.Session = {};

        if (this.RequestHeaders && this.RequestHeaders.Authorization) {
          var auth = this.RequestHeaders.Authorization;

          if (auth.startsWith('Bearer ')) {
            auth = auth.substring(7);
            var claim = Utils.parseJwt(auth);
            for (var k in claim) {
              const i = k.lastIndexOf('/');
              this.User[(i > 0) ? k.substring(i + 1) : k] = claim[k];
            }

          }
          this.RequestHeaders['Authorization'] = 'Bearer TOKEN';

        }

        if (this.CustomData)
        {
          for (var k in this.CustomData) {
            if (this.CustomData[k] == null || this.CustomData[k] == undefined || this.CustomData[k] == '') {
              delete this.CustomData[k];
              continue;
            }

            if (k.startsWith('Claim_')) {
              this.User[k.substring(6)] = this.CustomData[k];
              delete this.CustomData[k];
            } else if (k.startsWith('Session_')) {
              this.Session[k.substring(8)] = this.CustomData[k];
              delete this.CustomData[k];
            } else {

            }
          }
        }
        if (this.User && this.User.permissions) {

 
          var vl = this.User.permissions;

          if (this.isBase64(vl) && vl.indexOf(',') === -1) {
            var byteArray = this.base64ToUint8Array(vl);
            var ushortPermissionList = new Uint16Array(byteArray.buffer);

            this.User.permissions = Array.from(ushortPermissionList, item => item);
          } else {
            this.User.permissions = vl.split(',').map((x: any)  => parseInt(x, 10));
          }

         
        }
        if (this.Cookies && this.Cookies['LastUsername'] != null) {
          this.User.LastUsername = this.Cookies['LastUsername'];
        }

        if (!this.ClientSite && this.User.groupsid)
          this.ClientSite = this.User.groupsid;

        console.debug('User', this.User);

        // "FullUrl": "https://localhost:7252/api/ErrorLog/List",
        /*
    "CustomData": {
      "UserID": null,
      "Claim_aud": "optomiser-development.com",
      "Claim_iss": "optomiser-development.com",
      "Claim_exp": "1743535981",
      "Claim_iat": "1743622381",
      "Claim_nbf": "1743535981",
      "Claim_name": "Marco",
      "Claim_sid": "22",
      "Claim_role": "Support,Developer,Admin,Marketing,Impersonator"
  
      "ClientSite": "clearhorizons",
      "Claim_aud": "optomiser.com",
      "Claim_iss": "optomiser.com",
      "Claim_exp": "3/31/2025 3:21:59 PM",
      "Claim_iat": "3/31/2025 1:52:38 PM",
      "Claim_nbf": "3/31/2025 2:21:59 PM",
      "Claim_nameidentifier": "Mtautkus",
      "Claim_sid": "3",
      "Claim_groupsid": "clearhorizons",
      "Claim_usersessionid": "21903",
      "Claim_email": "mtautkus@clearhorizons.org",
      "Claim_permissions": "1,3,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,57,59,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,95,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,151,152,153,154,155,156,157,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,183,184,185,186,187,188,189,190,191,192,193,194,195,196,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,243,244,245,246,247,252,255,256,301,302,1000,1001,1002,1003,1004,1005,1006,1008,1009,1010,1011,1012,2001,2002,3000,3001,3002,3003,3004,3005,3006,3007,3008,3009,3010,3011,3012,3013,3018,3019,3020,3021,3022,3023,3024,3025,3026,3027,3028,3029,3030,3031,3032,3033,3034,3035,3036,3037,3038,3039,3040,3041,3042,3043,3044,3045,3046,3047,3048,3049,3050,3051,3052,3053,3054,3055,3056,3057,3058,3059,3060,3061,3062,3063,3064,3065,3066,3067,3068,3069,3070,3071,3072,3073,3074,3075,3076,3077,3078,3079,3080,3081,3082,3083,3084,3085,3086,3087,3088,3089,3090,3091,3092,3093,3094,3095,3096,3098,3099,3100,3101,3102,3103,3104,3105,3106,3110,3111,3112,3113,3114,3115,3116,3117,3118,3119,3120,3121,3122,3123,3126,3137,3200,3201,3202,3203,3204,3205,3206,3207,3208,3209,3210,3211,3300,3301,3302,3411,3412,3413,3421,3422,3423,3424,3431,4000,4001,4002,4003,4004,4005,4006,4007,4014,4018,4020,4021,4022,4023,4024,4025,4026,4027,4028,4029,4030,4035,4036,4040,4041,4042,4043,4045,4046,4050,4052,4053,4054,4055,4056,4057,4058,4059,4060,4065,4070,4075,4076,4077,4080,4081,4085,4091,4095,4100,4101,4102,4103,4113,4500,4510,5000,6000,6001,6002,6003,6008,6030,6050,6051,6100,6500,7000,7500,7501,7502,7601,8001,8003,9001,9002,9003,9004,9501,10001,10002,11000,11001,11002,11003,11005,11006,11008,11009",
      "Claim_timeout": "60",
      "Claim_expireonsessionend": "true",
      "Session_PatientID": "758",
      "Session_KeepSessionAlive": "3/31/2025 10:41:39 AM"
    }
  
  
        */
        for (var k in this.FullJson) {
          if (this.FullJson[k] == null || this.FullJson[k] == undefined)
            delete this.FullJson[k];
        }
        console.debug('FullJson', this.FullJson);

      } catch (ex) {
        console.error('Error parsing FullJson', ex);
      }

    }

    if (data.Detail) {

      {

        let maxE = data.Detail.indexOf('Full Trace');
        if (maxE < 0)
          maxE = data.Detail.length;

        let e = data.Detail.indexOf(':line') ;
        if (e > 0 && e < maxE) {
          let s = data.Detail.lastIndexOf(' in ', e);
          if (s > 0) {
            
            let f = data.Detail.substring(s + 4, e);
            if (f.indexOf('\\OptoMiser\\') > 0)
              f = f.substring(f.indexOf('\\OptoMiser\\') );
            else if (f.indexOf('\\optomiser_app\\') > 0)
              f = f.substring(f.indexOf('\\optomiser_app\\') );
            
            this.SourceFile = f;
            s = e + 5;
            e = data.Detail.indexOf('\n', e);
            if (e < 0)
              e = data.Detail.length;
            this.SourceFileLine = parseInt(data.Detail.substring(s, e));
          }
        }
        // 
      }

    }



  }

  delete() {
    this.currentItem?.CreationDate

    let ids = [] as number[];
    if (this.currentItem)
      ids.push(this.currentItem.ID || 0);
    if (this.currentItem && this.currentItem.Duplicates && this.currentItem.Duplicates.length>0)
      for (let i of this.currentItem?.Duplicates)
        ids.push(i.ID|| 0);

    this.loading = true;
    this.apiService.Delete({ body: { id: ids } })
      .forEach(
        () => {

          this.loading = false;
          this.currentItem = undefined;
          this.alertService.success('Item deleted successfully', true);
          this.router.navigate(['/exceptionlog']);
        }).catch(
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));

          });


  }



  getTimeFromNow(date: Date) {
    if ((new Date().getTime()) - (new Date(date).getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(date, 'shortDate', 'en-US');
    }
    return Utils.getTimeFromNow(date);
  }
  formatMountainTime(date: Date | string | undefined | null) {

    return Utils.formatMountainTime(date);
  }
  getMonitorLink() {
    let store = (environment.production) ? 'UTBS' : 'Dev';
    
    return "https://monitor.optomiser-development.com/exceptions/detail?id=" + this.currentItem?.GUID + '&store=' + store;
  }
  

  getCodeLink() {
    if (!this.SourceFile || !this.SourceFile.startsWith("\\"))
      return null;
    let store = (environment.production) ? 'production' : 'QA';
    return "https://github.com/UTBS/utbs_optomiser/blob/" + store +  this.SourceFile.replace("\\", "/") + "#L" + this.SourceFileLine;
  }
  serializableToObj(data: any) {
    var a = data as [];
    if (!a)
      return data;
    if (a.length == 0)
      return null;

    var obj = {};

    for (var k = 0; k < a.length; k++) {
      var key = a[k]['Name'] || k.toString();
      var value = a[k]['Value'];
      obj[key] = value;
    }


    return obj;
  }

  isEmptyObj(data: any) {
    if (!data)
      return true;

    for (var k in data) {
      if (data[k] != null && data[k] != undefined && data[k] != '')
        return false;
    }

    return true;
  }
  isBase64(str: string): boolean {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }

  base64ToUint8Array(base64: string): Uint8Array {
    var binaryString = atob(base64);
    var len = binaryString.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  getFormatedDateFromUnixTime(str: any): string {

    if (typeof str === 'object')
      return this.formatMountainTime(new Date(str));

    let date;
    let unixTimestamp = 0;
    // check if the string is a number
    if (typeof str === 'number') {
      // check if the string is a unix timestamp
      unixTimestamp = str as number;
    } else  if ( /^\d+$/.test(str)) {
        unixTimestamp = parseInt(str);
    }
    if (unixTimestamp > 0) {
      date = new Date(unixTimestamp * 1000)
    }
    else if (str.indexOf('/') > 0) {
      return str;
    }
    else {
      date = Utils.getDateFromISODate(str);
    }
    return this.formatMountainTime(date);  
  }


  showLinkGitHub() {

    if (this.currentItem?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${this.currentItem?.GitHub_Repository}/issues/${this.currentItem?.GitHub_IssueNumber}`;
      var w = window.open(url);
      if (!w)
        location.href = url;
      return;
    }

    this.gitHubIssueVisible = true;

    if (!this.gitHubIssues) {
      this.loadingGitHubIssue = true;
      this.apiService.GetGitHubIssues()
        .forEach((result) => {
          this.loadingGitHubIssue = false;
          result.splice(0, 0, { title: 'New Issue', number: 0, repository: 'utbs_optomiser' } );

          this.gitHubIssues = result;
          var myTitle = `${this.currentItem?.Type}: ${this.currentItem?.Message}`;
          var r = result.find(x => x.title && myTitle.startsWith(x.title))
          if (!r)
            r = result[0];
          
          this.gitHubIssue = r;

        }).catch(
          err => {
            this.loadingGitHubIssue = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    }

  }


  linkGitHub() {
    if (!this.currentItem || !this.currentItem.ID || !this.gitHubIssue)
      return;
    console.debug(this.gitHubIssue);


    let ids = [] as number[];
    if (this.currentItem)
      ids.push(this.currentItem.ID || 0);
    if (this.currentItem && this.currentItem.Duplicates && this.currentItem.Duplicates.length > 0)
      for (let i of this.currentItem?.Duplicates)
        ids.push(i.ID || 0);

    this.loading = true
    this.apiService.LinkGitHubIssue({
      body: {
        exceptionIDs: ids,
        GitHub_IssueNumber: this.gitHubIssue.number,
        GitHub_Repository: this.gitHubIssue.repository || undefined,
        comment: this.gitHubComment || undefined
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.gitHubIssueVisible = false;
        this.currentItem!.GitHub_IssueNumber = result.number;
        this.currentItem!.GitHub_Repository = result.repository;
        this.alertService.success('Item linked successfully');

      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }
  
  showLinkTicket() {
    if (this.currentItem?.SupportTicketID) {
      this.router.navigate(['/tickets', this.currentItem?.SupportTicketID]);
      return;
    }

    this.ticketVisible = true;

    if (!this.tickets) {
      this.loadingTicket = true;
      this.apiService.GetBugSupportTickets()
        .forEach((result) => {
          this.loadingTicket = false;
          if (result.length == 0) {

            this.alertService.info('No open bug support tickets');
          }

          this.tickets = result;

          var r = result.filter(x => x.Client && x.Client == this.ClientSite);
          if (r.length > 0)
            this.ticket = r[0];
          else
            this.ticket = result[0];

        }).catch(
          err => {
            this.loadingTicket = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    }
  }
  linkTicket() {
    if (!this.currentItem || !this.currentItem.ID || !this.ticket)
      return;
    console.debug(this.ticket);


    this.loading = true
    this.apiService.LinkSupportTicket({
      body: {
        exceptionIDs: [this.currentItem!.ID || 0],
        supportTicketID: this.ticket.ID         
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.ticketVisible = false;
        this.currentItem!.SupportTicketID = this.ticket!.ID;
        this.alertService.success('Item linked successfully');

      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }

}
